// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"142":"analytics","296":"style","346":"blocks","421":"contacts","535":"login","641":"site"}[chunkId] || chunkId) + "." + {"142":"b05dba0b","296":"978ede8c","331":"1f8ed542","346":"536211ab","365":"47f5f6c6","421":"c18b0181","535":"e2515c3c","641":"78225f34"}[chunkId] + ".js";
};